// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'apikeys'"
  name="API Key"
  parentRoute="apikeys"
  permissions="apikeys"
  :values="values"
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Locked',
                value: 'locked',
                type: 'checkbox'
              },
              {
                name: 'Roles',
                value: 'roles',
                context: ENDPOINT + 'roles',
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                multiple: true,
                required: true
              },
              {
                name: 'Token',
                value: 'token',
                disabled: true
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ApiKeyEdit.vue